<template>
  <div class="form">
    <Form2ItemInput
      v-model="credential"
      ref="credential"
      label="请输入原密码"
      type="password"
      :required="true"
      :rule="[
        { type: `string`, required: true, message: `原密码不能为空`, trigger: `blur` },
      ]"
    />
    <Form2ItemInput
      v-model="newCredential"
      ref="newCredential"
      label="新登录密码为6-20位字母和数字的组合"
      max="20"
      type="password"
      :required="true"
      :rule="[
        { type: `string`, required: true, message: `新登录密码不能为空`, trigger: `blur` },
        { validator: this.validatePassword2, trigger: 'blur'}
      ]"
    />
    <div>
      <Button @click="$router.push(`/user/safe/list`)">
        取消
      </Button>
      <Button
        class="ml"
        type="primary"
        @click="submit">
        下一步
      </Button>
    </div>
  </div>
</template>

<script>
import Form2ItemInput from '@/components/form2-item-input';
import {retrievePwd} from '@/service';
import {encrypt} from '@/util';
import pattern from '@/util/pattern';

export default {
  name: 'Index',
  components: {Form2ItemInput},
  data() {
    return {
      pattern,
      credential: '',
      newCredential: '',
    };
  },
  methods: {
    validatePassword1(rule, val, cb) {
      const v1 = pattern.isLetter(1).test(val);
      const v2 = pattern.isNumber(1).test(val);
      const v3 = val.length >= 6 && val.length <= 20;
      if (v1 && v2 && v3) {
        cb();
      } else {
        cb(new Error('原密码不正确'));
      }
    },
    validatePassword2(rule, val, cb) {
      const v1 = pattern.isLetter(1).test(val);
      const v2 = pattern.isNumber(1).test(val);
      const v3 = val.length >= 6 && val.length <= 20;
      if (v1 && v2 && v3) {
        cb();
      } else {
        cb(new Error('新密码不正确'));
      }
    },
    submit() {
      if (this.credential === this.newCredential) return this.$Message.error('新密码与原密码不能一致');
      Promise.all([
        this.$refs['credential'].validate(),
        this.$refs['newCredential'].validate(),
      ]).then(([valid1, valid2, valid3]) => {
        if (valid1 && valid2) {
          retrievePwd({
            identifier: this.$store.state.user.userAuth.identifier,
            credential: encrypt(this.credential),
            newCredential: encrypt(this.newCredential),
          }).then(({resultDesc}) => {
            this.$emit('success');
          });
        }
      });
    },
  },
};
</script>
